var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadless(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4706 23.0294L16.6765 23.8235H10.3235L9.52941 23.0294H0C0 25.2223 1.77771 27 3.97059 27H23.0294C25.2223 27 27 25.2223 27 23.0294H17.4706Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.293 6.35291H20.6459V10.3235H14.293V6.35291Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9791 22.2353H16.0163L16.8104 21.4411H25.4095V6.35291H22.233V11.9117H14.2918V13.6004C15.6604 13.954 16.6742 15.199 16.6742 16.6764C16.6742 18.4279 15.2492 19.8529 13.4977 19.8529C11.7462 19.8529 10.3212 18.4279 10.3212 16.6764C10.3212 15.1991 11.3351 13.954 12.7036 13.6004V11.9117H4.76241V6.35291H1.58594V21.4411H10.185L10.9791 22.2353ZM18.2624 14.2941H22.233V15.8823H18.2624V14.2941ZM18.2624 17.4706H22.233V19.0588H18.2624V17.4706ZM8.733 19.0588H4.76241V17.4706H8.733V19.0588ZM8.733 15.8823H4.76241V14.2941H8.733V15.8823Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5023 18.2646C14.3795 18.2646 15.0905 17.5535 15.0905 16.6764C15.0905 15.7992 14.3795 15.0881 13.5023 15.0881C12.6251 15.0881 11.9141 15.7992 11.9141 16.6764C11.9141 17.5535 12.6251 18.2646 13.5023 18.2646Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35547 6.35291H12.7084V10.3235H6.35547V6.35291Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3534 4.76471H8.73575V0H2.38281V4.76471H4.76517V6.35294H6.3534V4.76471Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2362 4.76471H24.6186V0H18.2656V4.76471H20.648V6.35294H22.2362V4.76471Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2909 4.76471H16.6733V0H10.3203V4.76471H12.7027V6.35294H14.2909V4.76471Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadless);
export default __webpack_public_path__ + "static/media/headless.b102750b9f854cff670bfd106a019383.svg";
export { ForwardRef as ReactComponent };